import { useEffect, useRef } from 'react';
import { useNotifyStore } from '../store/notifyStore.js';

const TYPES = {
  success: { label: 'Успех', color: '#34c759' },
  error: { label: 'Ошибка', color: '#ef4444' },
  info: { label: 'Информация', color: '#002882' },
};

function ToastItem({ id, type, message, onDone }) {
  const timer = useRef(/** @type {ReturnType<typeof setTimeout>|null} */ (null));

  useEffect(() => {
    timer.current = setTimeout(onDone, 4000);
    return () => { if (timer.current) clearTimeout(timer.current); };
  }, [onDone]);

  const def = TYPES[type] || TYPES.info;

  return (
    <div className="flex items-start gap-3 p-4 rounded-xl border animate-slide-in bg-white shadow-lg" style={{ borderColor: def.color + '33' }}>
      <span className="w-2 h-2 rounded-full mt-2 shrink-0" style={{ background: def.color }} />
      <div className="min-w-0">
        <span className="text-xs font-semibold uppercase tracking-wider" style={{ color: def.color }}>{def.label}</span>
        <p className="text-sm text-gray-700 mt-0.5 leading-relaxed">{message}</p>
      </div>
      <button type="button" onClick={onDone} title="Закрыть" className="text-gray-400 hover:text-gray-600 shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 6 6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  );
}

export default function Toasts() {
  const toasts = useNotifyStore((s) => s.toasts);
  const remove = useNotifyStore((s) => s.remove);

  return (
    <div className="fixed top-16 right-4 z-50 space-y-2 max-w-sm w-full pointer-events-none">
      {toasts.map((t) => (
        <div key={t.id} className="pointer-events-auto">
          <ToastItem {...t} onDone={() => remove(t.id)} />
        </div>
      ))}
    </div>
  );
}